import { DragItem } from '@spa/scenes/Plannings/DnD'
import { DND_TYPE } from '@spa/scenes/Plannings/DnD/constant'
import { usePlanningPolicies } from '@spa/scenes/Plannings/redux/selectors'
import type { PropsWithChildren, FC, ReactElement } from 'react'
import React from 'react'

type DragNoteProps = {
  noteId: number
}

const DragNote: FC<PropsWithChildren<DragNoteProps>> = ({
  children = null,
  noteId
}) => {
  const { canDNDNote } = usePlanningPolicies()

  if (!canDNDNote) {
    return children as ReactElement
  }

  return (
    <DragItem id={noteId} type={DND_TYPE.NOTE}>
      {children}
    </DragItem>
  )
}

export default DragNote
